import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  CustomCollapseCard,
  CustomImage,
  CustomModal,
  CustomPopover,
  Text,
  useText,
  warningDialog,
} from '@src/components';
import { Affix, Button } from 'antd';
import { VouIdCode, monthsList, MobilExpressPaymentTypeCode } from '@src/store/enums';
import { useDispatch, useSelector } from 'react-redux';
import { moneyFormat } from '@src/utils/utils';
import {
  Cancel,
  finishPaymentProcess,
  processPayment,
  setCreditCardMatchVous,
  setPayLaterDayForThanksPage,
  setSelectStoredCard,
  setPayWithLinkinEmail,
} from '@src/store/slice/mobilExpressSlice';
import modalClose from '@src/assets/icons/icon-close.svg';
import { loadBalancesUpdate } from '@src/store/slice/balanceUploadSlice';
import dayjs from '@src/utils/day';
import { defaultDateFormat } from '@src/utils/keys';
import PayWithNewCard from '@src/pages/ticketRestaurant/paymentModals/payWithNewCard/payWithNewCard';
import PayWithEFTHavale from '@src/pages/ticketRestaurant/paymentModals/payWithEFTHavale/payWithEFTHavale';
import logoMobilExpress from '@src/assets/images/cardOrders/logo-mobilexpress.webp';
import logoAmex from '@src/assets/images/cardOrders/american-express-logo.png';
import logoVisa from '@src/assets/images/cardOrders/visa-inc-logo.svg';
import masterCardLogo from '@src/assets/images/cardOrders/mastercard-logo.svg';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import { createPortal } from 'react-dom';
import iconInfo from '@src/assets/icons/icon-bilgi.svg';
import classNames from 'classnames';
import PayWithNewCardCompliments from '../../paymentModals/payWithNewCardCompliments/payWithNewCardCompliments';
import PayWithSavedCardCompliments from '../../paymentModals/payWithSavedCardCompliments/payWithSavedCardCompliments';
import { getCustomerVouListForGift } from '@src/store/slice/customerSlice';

let paymentOrderDueDate = null;
let _selectedStoredCard = null;

const OrderSummary = ({ form, formVisible }) => {
  const { currentLoadBalance } = useSelector((state) => state?.balanceUpload);
  const { selectedCustomer } = useSelector((state) => state?.customer);
  const { selectedStoredCard, paymentType, payWithLinkinEmail, payLaterDayForThanksPage } =
    useSelector((state) => state?.mobilExpress);
  const { currentBank } = useSelector((state) => state?.bank);
  const { isSchool } = useSelector((state) => state?.auth);

  const [invoiceMonthText, setInvoiceMonthText] = useState('');
  const [threeDSecureContent, setThreeDSecureContent] = useState('');
  const [instantRemittance, setInstantRemittance] = useState('');
  const [saveCardBody, setSaveCardBody] = useState({ body: {}, checked: false });
  const [modals, setModals] = useState({
    threeDSecureModalVisible: false,
    instantRemittanceModalVisible: false,
    payWithNewCard: false,
    payWithEftHavale: false,
    payWithNewCardForCompliment: false,
    payWithSavedCardForCompliment: false,
  });
  const [afterMount, setAfterMount] = useState(false);
  const [isPayDayToday, setIsPayDayToday] = useState(false);
  const [showPayLater, setShowPayLater] = useState(false);
  const [payWhenBalanceActiveDate, setPayWhenBalanceActiveDate] = useState(false);
  const isMobil = useMediaQuery({ query: '(max-width: 991.98px)' });
  const isComplimentsVou = useMemo(
    () => currentLoadBalance?.vouId === VouIdCode.Compliments,
    [currentLoadBalance],
  );
  const isMarketVou = useMemo(
    () => currentLoadBalance?.vouId === VouIdCode.Market,
    [currentLoadBalance],
  );

  let textTRorTG;
  let vouId;

  switch (currentLoadBalance?.vouId) {
    case VouIdCode.Compliments:
      textTRorTG = 'Ticket Gift';
      vouId = VouIdCode.Compliments;
      break;

    case VouIdCode.Market:
      textTRorTG = 'Ticket Market';
      vouId = VouIdCode.Market;
      break;

    case VouIdCode.Restaurant:
    default:
      textTRorTG = 'Ticket Restaurant';
      vouId = VouIdCode.Restaurant;
      break;
  }

  const pleaseSelectOneOfYourStoredCards = useText('pleaseSelectOneOfYourStoredCards')
  const confirmLaterTextt = useText('confirmLaterText')
  const confirmLaterEmailText = useText('confirmLaterEmailText')
  const confirmSavedLaterTextt = useText('confirmSavedLaterText')
  const threeDSecurity = useText('3dSecurity');
  const modalAction = (prop, value) => {
    setModals((modals) => ({
      ...modals,
      [prop]: value,
    }));
  };

  const dispatch = useDispatch();

  useEffect(() => {
    const text = monthsList
      .filter((month) => month.value === currentLoadBalance?.invoiceMonth)
      .reduce((acc, month) => month.text, '');

    setInvoiceMonthText(text);
  }, [currentLoadBalance]);

  useEffect(() => {
    const today = dayjs().hour(23).minute(59).second(59);
    const activationDate = dayjs(currentLoadBalance?.activationDate)
      .hour(23)
      .minute(59)
      .millisecond(0)
      .second(59);
    setShowPayLater(activationDate.isAfter(today));
    setIsPayDayToday(activationDate.unix() === today.unix());
    setAfterMount(activationDate.month() > today.month() || activationDate.year() > today.year());
  }, [currentLoadBalance]);
  const paymentLater = async () => {
    if (isComplimentsVou && paymentType !== MobilExpressPaymentTypeCode.EftHavale) {
      modalAction('payWithSavedCardForCompliment', true);
    } else {
      modalAction('payWithNewCard', false);
      await finishOrder(true);
    }
  };

  const callPaymentLaterFunc = async (vals) => {
    await dispatch(
      setPayLaterDayForThanksPage(
        dayjs(currentLoadBalance?.activationDate).utc(true).utcOffset(180).toISOString(),
      ),
    );
    if (vals === 1) {
      try {
        await form.setFieldsValue({
          cardSaveChecked: true,
        });
        await form.validateFields();
      } catch (e) {
        console.error(e);
      }
      await dispatch(setPayWithLinkinEmail(false));
      //await saveNewCardPayLater();
    } else {
      await dispatch(setPayWithLinkinEmail(true));
      setPaymentOrderDueDate(null);
    }
    await finishOrder(true, vals);
  };

  const confirmLaterText = (vals) => {
    if ((isComplimentsVou || isMarketVou) && vals === 1) {
      return confirmLaterTextt;
    } else if ((isComplimentsVou || isMarketVou) && vals === 2) {
      return confirmLaterEmailText;
    } else if (vals) {
      return confirmLaterTextt;
    } else
      return confirmLaterEmailText;
  };

  const confirmSavedLaterText = (vals) => {
    if ((isComplimentsVou || isMarketVou) && vals === 1) {
      return confirmSavedLaterTextt;
    } else if ((isComplimentsVou || isMarketVou) && vals === 2) {
      return confirmLaterEmailText;
    } else if (vals) {
      return confirmLaterTextt;
    } else
      return confirmLaterEmailText;
  };
  const showPaymentLaterSecondStep = (vals) => {
    warningDialog({
      title: <Text t="attention" />,
      width: 640,
      htmlContent: (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <span className="compliments-med-text" style={{ textAlign: 'center' }}>
            <Text t="doYouApproveTheTransaction" />
          </span>
          <span style={{ textAlign: 'center' }}>{confirmLaterText(vals)}</span>
          <span style={{ textAlign: 'center' }}>
            <Text t="doYouWantToContinue" />
          </span>
          <button
            style={{ marginTop: 20 }}
            className="utts-ok-button comp-warn-confirm"
            onClick={async () => {
              callPaymentLaterFunc(vals);
            }}
          >
            <Text t="approve2" />
          </button>
          <button className="utts-cancel-button gift-cancel-order-cancel" onClick={() => null}>
            <Text t="giveUp" />
          </button>
        </div>
      ),
      className: 'warningModal-utts not-show-warning-buttons',
      okButtonProps: 'not-show-warning-buttons',
      onOk: async () => { },
      onCancel: async () => { },
    });
  };

  const showSavedPaymentLaterSecondStep = (vals) => {
    warningDialog({
      title: <Text t="attention" />,
      width: 640,
      htmlContent: (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <span className="compliments-med-text" style={{ textAlign: 'center' }}>
            <Text t="doYouApproveTheTransaction" />
          </span>
          <span style={{ textAlign: 'center' }}>{confirmSavedLaterText(vals)}</span>
          <span style={{ textAlign: 'center' }}>
            <Text t="doYouWantToContinue" />
          </span>
          <button
            style={{ marginTop: 20 }}
            className="utts-ok-button comp-warn-confirm"
            onClick={async () => {
              callPaymentLaterFunc(vals);
            }}
          >
            <Text t="approve2" />
          </button>
          <button className="utts-cancel-button gift-cancel-order-cancel" onClick={() => null}>
            <Text t="giveUp" />
          </button>
        </div>
      ),
      className: 'warningModal-utts not-show-warning-buttons',
      okButtonProps: 'not-show-warning-buttons',
      onOk: async () => { },
      onCancel: async () => { },
    });
  };

  useEffect(() => {
    _selectedStoredCard = selectedStoredCard;
  }, [selectedStoredCard]);

  const finishOrder = async (paymentLater = false, vals = undefined) => {
    const body = {
      ...currentLoadBalance,
      paymentLater,
      orderStatus: 90,
      sendMail: true,
    };
    if (paymentOrderDueDate && paymentType === MobilExpressPaymentTypeCode.CreditCard) {
      paymentOrderDueDate = null;
      if (!(isComplimentsVou || isMarketVou) && !isSchool) body.cardToken = _selectedStoredCard;
    }
    if (formVisible) {
      const formData = await form.getFieldsValue();
      const cardBin = formData.cardNumber?.replaceAll('-', '')?.slice(0, 6) || '';
      if (cardBin) {
        body.cardBin = cardBin;
      }
      await form.resetFields();
    }
    if ((isComplimentsVou || isMarketVou) && paymentLater && vals === 2) {
      body.dontSendBinAndToken = true;
    }
    if (isComplimentsVou || isMarketVou) {
      const giftCustomerInfo = await dispatch(
        getCustomerVouListForGift({
          customerId: selectedCustomer?.customerId,
          vouId: vouId,
        }),
      );
      if (giftCustomerInfo?.payload?.data[0]?.pamId) {
        body.paymentType = giftCustomerInfo?.payload?.data[0]?.pamId;
      }
      if (paymentType === MobilExpressPaymentTypeCode.EftHavale) {
        body.paymentType = 5;
      }
    }
    if (paymentType === MobilExpressPaymentTypeCode.EftHavale) {
      body.dontSendBinAndToken = true;
    }
    await dispatch(loadBalancesUpdate(body));
  };

  useEffect(() => {
    window.paymentLater = paymentLater;
    return () => {
      window.paymentLater = () => { };
    };
  }, [paymentLater]);

  const customerId = selectedCustomer?.customerId;
  const closeAllModals = () => {
    modalAction('threeDSecureModalVisible', false);
    modalAction('instantRemittanceModalVisible', false);
    modalAction('payWithNewCard', false);
  };

  const setPaymentOrderDueDate = (value) => (paymentOrderDueDate = value);

  const saveNewCardWithParam = async (price, isDump) => {
    const customerId = selectedCustomer?.customerId;
    const values = await form.validateFields();
    const body = {
      body: {
        currency: 'TRY',
        paymentInstrument: 'NewCard',
        paymentInstrumentInfo: {
          newCard: {
            processType: isDump ? 'preauth' : 'sales',
            use3DSecure: true,
            cvv: values?.cvv,
            cardInfo: {
              cardHolderName: values?.cardHolderName,
              cardNumber: values?.cardNumber?.replaceAll('-', ''),
              lastMonth: values?.lastMonth,
              lastYear: values?.lastYear,
            },
          },
        },
        returnUrl: `${process.env.VITE_SITE_URL}/payment-result.html?paymentInstrument=NewCard${isDump ? '&PaymentReferenceType=preauth' : ''
          }`,
        totalAmount: price,
        customerInfo: { customerId: customerId?.toString() },
      },
      paymentReferenceType: isDump ? 3 : 2,
      referenceId: isDump ? '1' : currentLoadBalance?.id?.toString(),
    };
    return dispatch(processPayment(body));
  };

  const saveNewCardPayLater = async (setPaymentLater = false) => {
    const action = await saveNewCardWithParam(1, true);
    const values = await form.validateFields();
    if (processPayment.fulfilled.match(action)) {
      const data = action?.payload?.data;
      if (data?.result === 'Success') {
        await handleOrderFinish(setPaymentLater);
        return;
      }
      modalAction('payWithNewCard', false);
      setThreeDSecureContent(
        'data:text/html;charset=utf-8,' + encodeURIComponent(action?.payload?.data?.redirectForm),
      );
      modalAction('threeDSecureModalVisible', true);
      setSaveCardBody({ body: values, checked: true, paymentLater: setPaymentLater });
    }
  };

  const saveNewCard = async () => {
    modalAction('payWithNewCard', false);
    const values = await form.validateFields();
    try {
      const action = await saveNewCardWithParam(currentLoadBalance?.totalPrice, false);
      if (processPayment.fulfilled.match(action)) {
        const data = action?.payload?.data;
        if (data?.result === 'Success') {
          await handleOrderFinish();
          return;
        }
        setThreeDSecureContent(
          'data:text/html;charset=utf-8,' + encodeURIComponent(action?.payload?.data?.redirectForm),
        );
        modalAction('threeDSecureModalVisible', true);
        if (values.cardSaveChecked) {
          setSaveCardBody({ body: values, checked: true });
        }
      }
    } catch (e) { }
  };

  const [isValid, setIsValid] = useState(false);
  useEffect(async () => {
    const values = await form?.getFieldsValue();

    const cardNumber = values?.cardNumber?.replaceAll('_', '').replaceAll('-', '');
    const cardNumberLength = cardNumber?.length;
    const cardNumberIsValid = cardNumberLength === 16;

    const cardHolderName = values?.cardHolderName;
    const cardHolderNameIsValid = cardHolderName?.length > 0;

    const lastMonth = values?.lastMonth;
    const lastMonthIsValid = lastMonth > 0;

    const lastYear = values?.lastYear;
    const lastYearIsValid = lastYear?.length > 0;

    const cvv = values?.cvv?.replaceAll('_', '');
    const cvvIsValid = cvv?.length > 2;

    setIsValid(
      cardNumberIsValid &&
      cardHolderNameIsValid &&
      lastMonthIsValid &&
      lastYearIsValid &&
      cvvIsValid,
    );
  });

  async function formVisibleMethod() {
    const values = await form.validateFields();
    const { cardSaveChecked } = values;
    if (isPayDayToday || !afterMount) {
      await saveNewCard();
    } else if (afterMount) {
      if (cardSaveChecked) {
        await saveNewCardPayLater();
      } else {
        if (isSchool) {
          return finishOrder(true);
        }
        modalAction('payWithNewCard', true);
      }
    }
  }

  const handlePayment = useCallback(async () => {
    closeAllModals();
    const customerId = selectedCustomer?.customerId;
    if (paymentType === MobilExpressPaymentTypeCode.EftHavale) {
      modalAction('payWithEftHavale', true);
      return;
    }
    if (formVisible) {
      await formVisibleMethod();
    } else if (paymentType === MobilExpressPaymentTypeCode.CreditCard) {
      const body = {
        body: {
          currency: 'TRY',
          paymentInstrument: 'StoredCard',
          paymentInstrumentInfo: {
            storedCard: {
              processType: 'sales',
              use3DSecure: false,
              cardToken: selectedStoredCard,
            },
          },
          returnUrl: `${process.env.VITE_SITE_URL}/payment-result.html?paymentInstrument=StoredCard`,
          customerInfo: { customerId: customerId.toString() },
          totalAmount: currentLoadBalance?.totalPrice,
        },
        paymentReferenceType: 2,
        referenceId: currentLoadBalance?.id?.toString(),
      };

      const action = await dispatch(processPayment(body));
      if (processPayment.fulfilled.match(action)) {
        const data = action?.payload?.data;
        if (data?.result === 'Success') {
          await handleOrderFinish();
        } else {
          setThreeDSecureContent(
            'data:text/html;charset=utf-8,' +
            encodeURIComponent(action?.payload?.data?.redirectForm),
          );
          modalAction('threeDSecureModalVisible', true);
        }
      }
    } else if (currentBank === 'paymentLater') {
      await finishOrder(true);
    } else {
      const body = {
        body: {
          currency: 'TRY',
          paymentInstrument: 'DirectWireTransfer',
          paymentInstrumentInfo: {
            directWireTransfer: {
              bankAccountId: currentBank?.accountId,
            },
          },
          returnUrl: `${process.env.VITE_SITE_URL}/payment-result.html?paymentInstrument=DirectWireTransfer`,
          customerInfo: { customerId: customerId.toString() },
          totalAmount: currentLoadBalance?.totalPrice,
          basketItems: [
            {
              name: 'string',
              criticalCategory: 'Other',
              quantity: 1,
              unitPrice: currentLoadBalance?.totalPrice,
            },
          ],
        },
        paymentReferenceType: 2,
        referenceId: currentLoadBalance?.id?.toString(),
      };

      const remittanceAction = await dispatch(processPayment(body));
      if (processPayment.fulfilled.match(remittanceAction)) {
        setInstantRemittance(
          'data:text/html;charset=utf-8,' +
          encodeURIComponent(remittanceAction.payload.data.redirectForm),
        );
        modalAction('instantRemittanceModalVisible', true);
      }
    }
  }, [
    dispatch,
    form,
    formVisible,
    selectedStoredCard,
    selectedCustomer,
    currentLoadBalance,
    paymentType,
    currentBank,
    payLaterDayForThanksPage,
    isPayDayToday,
  ]);

  const payWhenBalanceActiveDay = async () => {
    paymentOrderDueDate = dayjs(currentLoadBalance?.activationDate)
      .utc(true)
      .utcOffset(180)
      .toISOString();
    await dispatch(setPayLaterDayForThanksPage(paymentOrderDueDate));
    if (formVisible) {
      const values = await form.validateFields();
      const { cardSaveChecked } = values;
      setPayWhenBalanceActiveDate(true);
      if (cardSaveChecked) {
        await saveNewCardPayLater();
      } else {
        modalAction('payWithNewCard', true);
      }
    } else if (_selectedStoredCard) {
      await paymentLater();
    } else {
      warningDialog({
        title: <Text t="attention" />,
        message: pleaseSelectOneOfYourStoredCards,
      });
    }
  };

  useEffect(() => {
    window.payWhenBalanceActiveDay = payWhenBalanceActiveDay;
    return () => {
      window.payWhenBalanceActiveDay = () => { };
    };
  }, [payWhenBalanceActiveDay]);

  const handleOrderFinish = useCallback(
    async (setPaymentLater = false) => {
      await finishOrder(setPaymentLater ? setPaymentLater : false);
    },
    [currentLoadBalance, dispatch],
  );

  const isVerifiedPayment = useCallback(async () => {
    document?.activeElement?.blur();
    if (afterMount) {
      if (formVisible) {
        modalAction('payWithNewCard', true);
        await form.validateFields();
      }
      paymentOrderDueDate = dayjs(currentLoadBalance?.activationDate)
        .utc(true)
        .utcOffset(180)
        .toISOString();
      await dispatch(setPayLaterDayForThanksPage(paymentOrderDueDate));
      if (!formVisible) {
        await paymentLater();
        return;
      }
    }
    if (payWithLinkinEmail) {
      await paymentLater();
      return;
    }
    await handlePayment();
  }, [
    afterMount,
    currentLoadBalance,
    dispatch,
    form,
    formVisible,
    handlePayment,
    payWithLinkinEmail,
  ]);

  const finishPaymentProcessHandlerFunc = useCallback(
    async (body) => {
      try {
        const action = await dispatch(finishPaymentProcess(body));
        if (finishPaymentProcess.fulfilled.match(action)) {
          if (body.paymentReferenceType === 3) {
            await dispatch(
              Cancel({
                body: {
                  orderId: body.body.orderId,
                  paymentInstrument: 'newCard',
                  transactionReason: 'Ön Provizyon İptal',
                },
              }),
            );
          }
          if (saveCardBody.checked) {
            const body = {
              saveCardBody: {
                customerInfo: {
                  customerId: customerId?.toString(),
                },
                cardHolterName: saveCardBody?.body?.cardHolderName,
                cardNumber: saveCardBody?.body?.cardNumber?.replaceAll('-', ''),
                cardMonth: saveCardBody?.body?.lastMonth,
                cardYear: saveCardBody?.body?.lastYear,
                selectedVous: [
                  {
                    vouId: 1,
                    vouName: 'TICKET RESTAURANT',
                  },
                ],
              },
              creditCartVouMatchList: [
                {
                  customerId: customerId?.toString(),
                  vouId: 1,
                  provisionDay: 0,
                  type: 0,
                },
              ],
            };
            const newCardResponse = await dispatch(setCreditCardMatchVous(body));
            if (setCreditCardMatchVous.fulfilled.match(newCardResponse)) {
              const newCardToken = newCardResponse?.payload?.data?.cardToken;
              await dispatch(setSelectStoredCard(newCardToken));
              _selectedStoredCard = newCardToken;
              paymentOrderDueDate = true;
            }
          }
          if (formVisible) {
            if (payWhenBalanceActiveDate) {
              setPayWhenBalanceActiveDate(false);
              await handleOrderFinish(saveCardBody?.paymentLater);
              return;
            }
          }

          await handleOrderFinish(saveCardBody?.paymentLater);
        } else {
          modalAction('threeDSecureModalVisible', false);
        }
      } catch (e) { }
    },
    [
      dispatch,
      form,
      formVisible,
      handleOrderFinish,
      saveCardBody?.body,
      saveCardBody.checked,
      saveCardBody?.paymentLater,
    ],
  );

  const iframeOnLoad = useCallback(
    (queryString) => {
      if (queryString) {
        const urlParams = new URLSearchParams(queryString);
        const paymentInstrument = urlParams.get('paymentInstrument');
        const orderId = urlParams.get('OrderId');
        const systemTransId = urlParams.get('SystemTransId');
        const totalAmount = urlParams.get('TotalAmount');
        const paymentReferenceType = urlParams.get('PaymentReferenceType');

        const isPreAuth = paymentReferenceType === 'preauth';

        if (paymentInstrument && orderId && systemTransId) {
          const body = {
            paymentReferenceType: 2,
            referenceId: currentLoadBalance?.id,
            body: {
              orderId,
              merchantProcessId: 'IslemId33',
              systemTransId: systemTransId,
              paymentInstrument: paymentInstrument,
              paymentInstrumentInfo: {},
              totalAmount: +totalAmount,
            },
          };

          if (paymentInstrument === 'NewCard') {
            body.body.paymentInstrumentInfo = {
              newCard: {},
            };
          } else {
            body.body.paymentInstrumentInfo = {
              storedCard: { otp: '', cvv: '' },
            };
          }

          if (isPreAuth) {
            body.paymentReferenceType = 3;
            body.referenceId = '1';
            body.body.paymentInstrumentInfo = {
              newCard: {},
            };
          }
          (async () => {
            await finishPaymentProcessHandlerFunc(body);
          })();
        } else {
          modalAction('threeDSecureModalVisible', false);
        }
      }
    },
    [currentLoadBalance?.id, finishPaymentProcessHandlerFunc],
  );

  useEffect(() => {
    window.finishPaymentProcessHandler = iframeOnLoad;
    window.modalAction = modalAction;
    return () => {
      window.finishPaymentProcessHandler = () => { };
      window.modalAction = () => { };
    };
  }, [iframeOnLoad]);

  useEffect(() => {
    window.handlePayment = isVerifiedPayment;
    return () => {
      window.handlePayment = () => { };
    };
  }, [isVerifiedPayment]);

  let isDisabled = false;
  if (paymentType === MobilExpressPaymentTypeCode.CreditCard) {
    isDisabled = formVisible ? !isValid : !selectedStoredCard;
  }

  const handlePayLater = useCallback(async () => {
    if (formVisible && isDisabled) {
      modalAction('payWithNewCard', true);
      return null;
    }
    await payWhenBalanceActiveDay();
  }, [formVisible]);

  const getRightButtonText = () => {
    if (paymentType === MobilExpressPaymentTypeCode.EftHavale || afterMount) return <Text t="continue" />;
    else if (isComplimentsVou || isMarketVou) return <Text t="confirmPayment" />;
    return <Text t="payNow" />;
  };

  return (
    <div className="payment-order-summary-content">
      <CustomCollapseCard bodyCenter cardTitle={<Text t="orderSummary" />}>
        <div className="payment-order-summary-container">
          <div className="payment-order-summary-list">
            <span className="summary-title"><Text t="autoActivationDate" />:</span>
            <p>{dayjs(currentLoadBalance?.activationDate).format(defaultDateFormat)}</p>

            <span className="summary-title">
              <Text t="invoiceMonth2" />
            </span>
            <p>{invoiceMonthText}</p>

            <span className="summary-title">{<Text t="invoiceAddress2" />} </span>
            <p className="address-label">{currentLoadBalance?.invoiceAddress}</p>
          </div>

          <div className="summary-info-box">
            <span className="summary-title">
              <Text t="numberOfCards3" />
            </span>
            <p>{currentLoadBalance?.totalCount}</p>
          </div>

          <div className="summary-total-price-info-box">
            <span className="summary-title">
              <Text t="totalBalanceLoad" />
            </span>
            <p>{moneyFormat(currentLoadBalance?.totalPrice, true)}</p>
          </div>

          <div className="summary-total-price-info-box">
            <span className="summary-title">
              <Text t="totalAmountToBePaid" />
            </span>
            <p>{moneyFormat(currentLoadBalance?.totalPaymentAmount, true)}</p>
          </div>

          <span className="approval-text">
            {useText("iApproveTheOrderAndPaymentDetailedAbove").replaceAll('Ticket Restaurant', textTRorTG)}
          </span>
          {!isMobil &&
            showPayLater &&
            !afterMount &&
            currentLoadBalance.paymentType !== 5 &&
            !isSchool && (
              <div
                className={classNames({
                  'pay-when-balance-active-day-button': true,
                  right: true,
                })}
                onClick={handlePayLater}
              >
                <Text t="payLater" />
              </div>
            )}
          {!isMobil && (
            <Button
              id="balanceUpload-payment-orderSummary-desktop-payment-btn"
              disabled={afterMount && formVisible ? false : isDisabled}
              className="payment-btn"
              onClick={isVerifiedPayment}
            >
              {getRightButtonText()}
            </Button>
          )}
        </div>
      </CustomCollapseCard>
      {currentLoadBalance?.paymentType !== 5 && isMobil && (
        <div className="footer-logo">
          <div className="left-logos">
            <CustomImage className="logoMobil" src={logoMobilExpress} />
          </div>
          <span className={'pay-text'}>
            <Text t="yourCardsAreStoredSecurelyInThePci" />
          </span>
          <div className="right-logos">
            <CustomImage src={logoAmex} style={{ width: '50px', height: '50px' }} />
            <CustomImage src={logoVisa} />
            <CustomImage src={masterCardLogo} />
          </div>
        </div>
      )}

      {isMobil &&
        createPortal(
          <Affix offsetBottom={0}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#fff',
                padding: '18px 0',
              }}
            >
              <Button
                id="balanceUpload-payment-orderSummary-mobil-payment-btn"
                disabled={afterMount && formVisible ? false : isDisabled}
                className="payment-btn"
                onClick={isVerifiedPayment}
              >
                {getRightButtonText()}
              </Button>
              {showPayLater && !afterMount && currentLoadBalance.paymentType !== 5 && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-end',
                  }}
                >
                  <div
                    className={classNames({
                      'pay-when-balance-active-day-button': true,
                      right: true,
                    })}
                    onClick={handlePayLater}
                  >
                    <Text t="payLater" />
                  </div>
                  <CustomPopover
                    placement="topRight"
                    title={false}
                    content={
                      <div
                        style={{
                          width: '300px',
                          color: '#3f4957',
                          padding: '7px 18px',
                        }}
                      >
                        <Text t="ifYouSelectThisOptionTheTotalBalance" />
                      </div>
                    }
                    trigger="hover"
                    arrowPointAtCenter={true}
                  >
                    <div>
                      <CustomImage src={iconInfo} />
                    </div>
                  </CustomPopover>
                </div>
              )}
            </div>
          </Affix>,
          document.body,
        )}

      {modals.threeDSecureModalVisible && (
        <CustomModal
          width={500}
          maskClosable={false}
          footer={false}
          title={threeDSecurity}
          visible={modals.threeDSecureModalVisible}
          onCancel={() => modalAction('threeDSecureModalVisible', false)}
          closeIcon={<CustomImage src={modalClose} />}
        >
          <embed src={threeDSecureContent} width="100%" height="400" />
        </CustomModal>
      )}
      {modals.instantRemittanceModalVisible && (
        <CustomModal
          width={500}
          maskClosable={false}
          footer={false}
          title={'Anında Havale'}
          visible={instantRemittance}
          onCancel={() => modalAction('instantRemittanceModalVisible', false)}
          closeIcon={<CustomImage src={modalClose} />}
        >
          <embed src={instantRemittance} width="100%" height="400" />
        </CustomModal>
      )}
      {modals.payWithNewCard && (
        <PayWithNewCard
          setModalVisible={(value) => modalAction('payWithNewCard', value)}
          saveAction={() => {
            saveNewCardPayLater(true);
          }}
          paymentLater={paymentLater}
          orderDate={currentLoadBalance?.activationDate}
          setPaymentOrderDueDate={setPaymentOrderDueDate}
          formVisible={formVisible}
          form={form}
        />
      )}

      {modals.payWithEftHavale && (
        <PayWithEFTHavale
          orderDate={currentLoadBalance?.activationDate}
          modalAction={(value) => modalAction('payWithEftHavale', value)}
          paymentAction={paymentLater}
        />
      )}
      {modals.payWithNewCardForCompliment && (
        <PayWithNewCardCompliments
          setModalVisible={(value) => modalAction('payWithNewCardForCompliment', value)}
          form={form}
          clickHandler={(val) => showPaymentLaterSecondStep(val)}
          selectedIndex={selectedStoredCard}
        />
      )}
      {modals.payWithSavedCardForCompliment && (
        <PayWithSavedCardCompliments
          setModalVisible={(value) => modalAction('payWithSavedCardForCompliment', value)}
          form={form}
          clickHandler={(val) => showSavedPaymentLaterSecondStep(val)}
          selectedIndex={selectedStoredCard}
        />
      )}
    </div>
  );
};

export default OrderSummary;
